module.exports = __webpack_public_path__ + "static/media/apollo.05d89bbd.jpg";